/*
 * NEXZ V2 — overlay behavior (Stage C)
 * Covers only what has no CSS-only equivalent and is required for
 * WCAG 2.2 AA keyboard operability: drawer focus-trap + Esc-close +
 * focus restore, and native <dialog> wiring (showModal/close already
 * gives the dialog a focus trap and Esc-close for free; this only adds
 * backdrop-click-to-close and open/close triggers).
 *
 * No auto-behavior, no timers, no decorative motion logic — reveal/
 * scroll-triggered animation is intentionally out of Stage C.
 */
(function () {
  var FOCUSABLE =
    'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapFocus(panel, event) {
    var focusable = panel.querySelectorAll(FOCUSABLE);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function initDrawer(root) {
    var triggerSelector = root.getAttribute('data-nexz-drawer-trigger');
    var trigger = triggerSelector ? document.querySelector(triggerSelector) : null;
    var closeEls = root.querySelectorAll('[data-nexz-drawer-close]');
    var overlay = document.querySelector(root.getAttribute('data-nexz-drawer-overlay'));
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      root.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      document.body.classList.add('nexz-scroll-lock');
      var focusable = root.querySelectorAll(FOCUSABLE);
      if (focusable.length) focusable[0].focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      root.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      document.body.classList.remove('nexz-scroll-lock');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
      } else if (event.key === 'Tab') {
        trapFocus(root, event);
      }
    }

    if (trigger) trigger.addEventListener('click', open);
    closeEls.forEach(function (el) {
      el.addEventListener('click', close);
    });
    if (overlay) overlay.addEventListener('click', close);
  }

  function initDialog(dialog) {
    var triggerSelector = dialog.getAttribute('data-nexz-dialog-trigger');
    var trigger = triggerSelector ? document.querySelector(triggerSelector) : null;
    var closeEls = dialog.querySelectorAll('[data-nexz-dialog-close]');

    if (trigger) {
      trigger.addEventListener('click', function () {
        dialog.showModal();
      });
    }

    closeEls.forEach(function (el) {
      el.addEventListener('click', function () {
        dialog.close();
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  }

  document.querySelectorAll('[data-nexz-drawer]').forEach(initDrawer);
  document.querySelectorAll('[data-nexz-dialog]').forEach(initDialog);
})();
